innovationliving.cylindo = {
    const: {
        url: {
            getImageV4: 'https://content.cylindo.com/api/v2/{accountid}/products/{productCode}/frames/{frame}',
            getImageUrl: 'https://viewer-services.cylindo.com/standard/viewer/GetImageUrl',
            getProductConfigUrl: 'https://content.cylindo.com/api/v2/{accountid}/products/{productCode}/configuration'
        },
        allowRecallProductlistData: true,
        cylindoActiveFrameIndex: null,
        cylindoVideoFrameIndex: null,
        vimeoIframePlayer: null,
        isDownloadManager: jQuery( '.js-e-productlist-download' ).length > 0,
        default: {
            fabricMaterial: 521,
            position: 1
        },
        stored: {
            fabricMaterial: window.localStorage.getItem( 'innovationliving.cylindo.productlist.fabric' )
        },
        parameter: {
            fabricMaterial: e4.util.getUrlParameter( 'fabric' )
        },
        accountId: 4926
    },
    data: window.jsonFabrics || {},
    modifySKU: function ( strSku ) {
        if(strSku.length > 0){
            console.log('1_strSku', strSku);
            return strSku.split( '+' ).join( '%2B' );
        } else {
            console.log('2_strSku', strSku);
            return strSku+"";
        }
    },
    isFirstBuild: true,
    init: function () {
        if(jQuery('.js-product-cylindo').length > 0 && innovationliving.cylindo.isFirstBuild){
            innovationliving.cylindo.isFirstBuild = false;
            innovationliving.cylindo.start();
        } else {
            e4.productlist.jProductList.on( 'builded.e4.productlist', function ( event ) {
                if(innovationliving.cylindo.isFirstBuild){
                    innovationliving.cylindo.isFirstBuild = false;
                    innovationliving.cylindo.start();
                }
            } );

            if(innovationliving.cylindo.isFirstBuild) {
                jQuery( window ).on( 'load', function () {
                    innovationliving.cylindo.isFirstBuild = false;
                    innovationliving.cylindo.start();
                } );
            }
        }
    },
    start: function(){
        if ( jQuery( '.js-product-detail-fabric-container' ).length > 0 ) {
            e4.util.require.js( e4.settings.require.handlebars, function () {
                e4.handlebars.registerHelpers( 'compare' );
                e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-product-detail-fabric' );
                innovationliving.cylindo.requireCylindo();
            } );
        }
        else {
            innovationliving.cylindo.requireCylindo();
        }
    },
    productExists: function( strSku ){
        var strUrl = innovationliving.cylindo.const.url.getProductConfigUrl.split('{accountid}').join(innovationliving.cylindo.const.accountId).split( '{productCode}' ).join( strSku );
        var httpResponse = innovationliving.cylindo.get(strUrl);
        return httpResponse;
    },
    get: function ( strURL ) {
        if ( strURL !== undefined && strURL !== null && strURL !== '' ) {
            return jQuery.ajax( {
                url: strURL,
                cache: true,
                timeout: e4.settings.require.timeout,
                dataType: 'json',
            } );
        }
        else {
            return jQuery.Deferred().reject();
        }
    },
    requireCylindo: function () {
        var objScript = {
            url: '//cdnjs.cloudflare.com/polyfill/v3/polyfill.min.js?version=4.8.0&features=IntersectionObserver%2CIntersectionObserverEntry&flags=gated',
            callback: null
        };
        e4.util.require.js( objScript, function(){
            e4.util.require.js( e4.settings.require.cylindo, function () {
                innovationliving.cylindo.const.parameter.fabricMaterial = innovationliving.cylindo.getFabricIdFromParam( innovationliving.cylindo.const.parameter.fabricMaterial );
                if ( cylindo !== undefined ) {
                    innovationliving.cylindo.framework = cylindo;
                    innovationliving.cylindo.bindEvents();
                }
            } );
        });
    },
    bindEvents: function () {
        innovationliving.cylindo.framework.on( 'ready', function () {
            if ( jQuery( '.js-productlist-cylindo' ).length > 0 ) {
                innovationliving.cylindo.productlist.build();
                e4.productlist.jProductList.on( 'builded.e4.productlist', function () {
                    innovationliving.cylindo.productlist.build();
                } );
            }
            
            if ( jQuery( '.js-download-cart-orderlines-cylindo' ).length > 0 ) {
                innovationliving.cylindo.downloadmanager.build();
                var jDownloadCart = jQuery( '.js-e-download-cart' );
                jDownloadCart.on( 'loaded.e4.download', function () {
                    innovationliving.cylindo.downloadmanager.build();
                } );
            }

            var jCart = jQuery( '.js-e-cart' );
            if(jCart.length > 0){
                innovationliving.cylindo.cart.build();
                jCart.on( 'updated.e4.cart', function () {
                    if(jQuery( '.js-cart-orderlines-cylindo' ).length > 0){
                        innovationliving.cylindo.cart.build();
                    }
                } );
            }

            var jCheckout = jQuery('.js-e-checkout');
            if(jCheckout.length > 0){
                innovationliving.cylindo.cart.build();
                jCheckout.on( 'cartupdated.e4.checkout', function () {
                    if ( jQuery( '.js-cart-orderlines-cylindo' ).length > 0 ) {
                        innovationliving.cylindo.cart.build();
                    }
                } );
            }

            var jReceipt = jQuery('.js-e-checkout-receipt');
            if(jReceipt.length > 0){
                innovationliving.cylindo.cart.build();
                jReceipt.on( 'receiptshown.e4.checkout', function () {
                    if ( jQuery( '.js-cart-orderlines-cylindo' ).length > 0 ) {
                        innovationliving.cylindo.cart.build();
                    }
                } );
            }

            jQuery( '.js-e-search-form' ).on( 'loaded.e4.search showallloaded.e4.search', function () {
                console.log('loaded.e4.search showallloaded.e4.search');
                innovationliving.cylindo.productlist.build();
            } );
            if ( jQuery( '.js-product-cylindo' ).length > 0 ) {
                jQuery( '.js-product-cylindo' ).on( 'change', '.js-variant-color', function ( event ) {
                    var jElement            = jQuery( event.target ),
                        jElementCylindoList = jQuery( '.cylindo-threesixty-list' );
                    if ( innovationliving.cylindo.productdetail.viewer !== null ) {
                        var arrViewerFeatures = innovationliving.cylindo.productdetail.viewer.getFeatures();
                        console.log( 'change color', arrViewerFeatures );
                        arrViewerFeatures[ 1 ] = jElement.data( 'fabric' );
                        innovationliving.cylindo.changeFeatures( innovationliving.cylindo.productdetail.viewer, arrViewerFeatures );
                        innovationliving.cylindo.productdetail.createThumbnails();
                    }
                    if ( innovationliving.cylindo.const.cylindoVideoFrameIndex !== null ) {
                        if ( innovationliving.cylindo.const.vimeoIframePlayer !== null ) {
                            innovationliving.cylindo.const.vimeoIframePlayer.pause();
                        }
                        jElementCylindoList.find( 'li.active' ).removeClass( 'active' );
                        jElementCylindoList.find( 'li' ).eq( innovationliving.cylindo.const.cylindoActiveFrameIndex ).addClass( 'active' );
                        jElementCylindoList.removeClass('hide-360-icon');
                        innovationliving.cylindo.const.cylindoVideoFrameIndex = null;
                    }
                    innovationliving.cylindo.changeFabricInUrl( jElement.data( 'fabric' ) );
                    innovationliving.cylindo.productdetail.buildFabricContainer( jElement.data( 'fabric' ) );
                    jQuery( '.chosen-variant' ).text( jElement.data( 'title' ) );

                    var strProductNumber = jQuery( '.js-product-cylindo' ).find('.js-cylindo-viewer').data('number');
                    e4.product.getProduct(strProductNumber, jElement.data( 'fabric' ));
                } );
                jQuery( '.js-product-cylindo' ).on( 'click', '.js-cylindo-thumbs:not(.active)', function ( event ) {
                    var jElement            = jQuery( event.target ),
                        arrViewerFeatures   = innovationliving.cylindo.productdetail.viewer.getFeatures(),
                        jElementCylindoList = jQuery( '.cylindo-threesixty-list' );
                    if ( jElement.hasClass( 'js-cylindo-thumb-video' ) ) {
                        if ( jQuery( '.js-cylindo-viewer' ).data( 'videoProvider' ) === 'vimeo' ) {
                            innovationliving.cylindo.productdetail.activateVimeoVideoFrame( jElementCylindoList, event );
                        }
                        jElementCylindoList.addClass('hide-360-icon');
                    }
                    else {
                        if ( innovationliving.cylindo.const.cylindoVideoFrameIndex !== null ) {
                            if ( innovationliving.cylindo.const.vimeoIframePlayer !== null ) {
                                innovationliving.cylindo.const.vimeoIframePlayer.pause();
                            }
                            jElementCylindoList.find( 'li.active' ).removeClass( 'active' );
                            jElementCylindoList.find( 'li' ).eq( innovationliving.cylindo.const.cylindoActiveFrameIndex ).addClass( 'active' );
                            jElementCylindoList.removeClass('hide-360-icon');
                            innovationliving.cylindo.const.cylindoVideoFrameIndex = null;
                        }
                        console.log( 'arrViewerFeatures.length', arrViewerFeatures.length );
                        arrViewerFeatures[ 3 ] = jElement.data( 'position' );
                        innovationliving.cylindo.changeFeatures( innovationliving.cylindo.productdetail.viewer, arrViewerFeatures );
                    }
                    jQuery( '.js-product-cylindo' ).find( '.js-cylindo-thumbs' ).removeClass( 'active' );
                    jElement.addClass( 'active' );
                } );
                innovationliving.cylindo.productdetail.build();
            }
        } );
    },
    productdetail: {
        viewer: null,
        isViewerReady: false,
        build: function () {
            jQuery( '.js-product-cylindo' ).find( '.js-cylindo-viewer' ).each( function ( index, event ) {
                var jElement        = jQuery( event ),
                    strFabric       = innovationliving.cylindo.getActiveFabric(),
                    boolUsePimPacks = ( jElement.data( 'use-pim-packs' ) === 'True' || jElement.data( 'use-pim-packs' ) === 'true' || jElement.data( 'use-pim-packs' ) === true ),
                    objOptions      = {
                        //sku: innovationliving.cylindo.modifySKU( jElement.data( 'sku' ) ),
                        productCode: innovationliving.cylindo.modifySKU( jElement.data( 'sku' ) ),
                        accountID: innovationliving.cylindo.const.accountId,
                        features: [
                            'FABRIC',
                            strFabric,
                            'POSITION',
                            jElement.data( 'position' )
                        ],
                        country: 'us',
                        containerID: jElement.attr( 'id' ),
                        thumbs: false,
                        progressBar: false,
                        fallbackImage: jElement.data( 'fallback-image' ),
                        alternateContent: []
                    };
                if ( jElement.data( 'leg-finish' ) !== '' ) {
                    objOptions.features = [
                        'FABRIC',
                        strFabric,
                        'POSITION',
                        jElement.data( 'position' ),
                        'LEG FINISH',
                        jElement.data( 'leg-finish' )
                    ];
                }
                if ( jElement.data( 'video-provider' ).length > 0 ) {
                    if ( jElement.data( 'video-provider' ) === 'direct' ) {
                        objOptions.alternateContent.push( {
                            provider: jElement.data( 'video-provider' ),
                            description: '',
                            poster: jElement.data( 'video-thumb' ),
                            thumb: jElement.data( 'video-thumb' ),
                            sources: [
                                {
                                    src: jElement.data( 'video-src' ),
                                    type: 'video/mp4'
                                }
                            ]
                        } );
                    }
                    if ( jElement.data( 'video-provider' ) === 'youtube' ) {
                        objOptions.alternateContent.push( {
                            provider: jElement.data( 'video-provider' ),
                            url: jElement.data( 'video-src' ),
                            options: {
                                fs: 0
                            }
                        } );
                    }
                    if ( jElement.data( 'video-provider' ) === 'vimeo' ) {
                        objOptions.alternateContent.push( {
                            provider: jElement.data( 'video-provider' ),
                            url: jElement.data( 'video-src' ),
                            options: {
                                'autoplay': 0
                            }
                        } );
                    }
                }

                if ( jElement.data( 'video2-provider' ).length > 0 ) {
                    if ( jElement.data( 'video2-provider' ) === 'direct' ) {
                        objOptions.alternateContent.push( {
                            provider: jElement.data( 'video2-provider' ),
                            description: '',
                            poster: jElement.data( 'video2-thumb' ),
                            thumb: jElement.data( 'video2-thumb' ),
                            sources: [
                                {
                                    src: jElement.data( 'video2-src' ),
                                    type: 'video/mp4'
                                }
                            ]
                        } );
                    }
                    if ( jElement.data( 'video2-provider' ) === 'youtube' ) {
                        objOptions.alternateContent.push( {
                            provider: jElement.data( 'video2-provider' ),
                            url: jElement.data( 'video2-src' ),
                            options: {
                                fs: 0
                            }
                        } );
                    }
                    if ( jElement.data( 'video2-provider' ) === 'vimeo' ) {
                        objOptions.alternateContent.push( {
                            provider: jElement.data( 'video2-provider' ),
                            url: jElement.data( 'video2-src' ),
                            options: {
                                'autoplay': 0
                            }
                        } );
                    }
                }

                if ( boolUsePimPacks === true ) {
                    innovationliving.cylindo.setActiveFabric();
                    innovationliving.cylindo.switchToEspressoImageCarousel();
                    console.log('-1-', jElement.data('number'), jElement.data('fabric'));
                    e4.product.getProduct(jElement.data('number'), jElement.data('fabric'));
                }
                else {
                    innovationliving.cylindo.productExists(objOptions.productCode)
                            .done(function( data, textStatus, jqXHR ){
                                console.log('done', data, textStatus, jqXHR);
                                innovationliving.cylindo.productdetail.viewer = innovationliving.cylindo.framework.viewer.create( objOptions );
                                innovationliving.cylindo.productdetail.viewer.on( innovationliving.cylindo.productdetail.viewer.events.VIEWER_READY, function ( ) {
                                    if ( innovationliving.cylindo.productdetail.isViewerReady === false ) {
                                        innovationliving.cylindo.switchToCylindoViewer();
                                        innovationliving.cylindo.changeRotation( innovationliving.cylindo.productdetail.viewer );
                                        innovationliving.cylindo.productdetail.createThumbnails();
                                        innovationliving.cylindo.productdetail.isViewerReady = true;
                                        innovationliving.cylindo.setActivePosition();
                                        innovationliving.cylindo.setActiveFabric();
                                    }
                                } );
                            })
                            .fail(function( jqXHR, textStatus, errorThrown){
                                console.log('fail', jqXHR, textStatus, errorThrown);
                                innovationliving.cylindo.setActiveFabric();
                                innovationliving.cylindo.switchToEspressoImageCarousel();
                                console.log('-2-', jElement.data('number'), jElement.data('fabric'));
                                e4.product.getProduct(jElement.data('number'), jElement.data('fabric'));
                            });
                }
            } );
        },
        activateVimeoVideoFrame: function ( jElementCylindoList, event ) {
            var intIndexVideoThumb = jQuery(event.target).parent().find('.js-cylindo-thumb-video').index(event.target);
            if(jElementCylindoList.find( '.active' ).hasClass('cylindo-video') === false){
                innovationliving.cylindo.const.cylindoActiveFrameIndex = jElementCylindoList.find( '.active' ).index();
            }
            innovationliving.cylindo.const.cylindoVideoFrameIndex = jElementCylindoList.find( '.cylindo-video' ).eq(intIndexVideoThumb).index();
            jElementCylindoList.find( 'li.active' ).removeClass( 'active' );
            jElementCylindoList.find( 'li' ).eq( innovationliving.cylindo.const.cylindoVideoFrameIndex ).addClass( 'active' );
            if ( innovationliving.cylindo.const.vimeoIframePlayer === null ) {
                var iframe = document.querySelector( 'iframe#' + jElementCylindoList.find( 'li' ).eq( innovationliving.cylindo.const.cylindoVideoFrameIndex ).find( 'iframe' ).attr( 'id' ) );
                innovationliving.cylindo.const.vimeoIframePlayer = new Vimeo.Player( iframe );
            }
        },
        buildFabricContainer: function ( intFabricNumber ) {
            if ( jQuery( '.js-product-detail-fabric-container' ).length > 0 ) {
                jQuery( '.js-product-detail-fabric-container' ).html( e4.handlebars.tmpl.productDetailFabric( innovationliving.cylindo.data[ intFabricNumber ][ 0 ] ) );
            }
        },
        createThumbnails: function () {
            var arrMainViewerFeatures = innovationliving.cylindo.productdetail.viewer.getFeatures(),
                jMainViewer           = jQuery( '.js-product-cylindo' ).find( '.js-cylindo-viewer' );
            var strFallbackPosition   = arrMainViewerFeatures[ 3 ];
            jQuery( '.js-cylindo-thumbs' ).each( function ( intIndex, element ) {
                var jElement               = jQuery( element ),
                    arrCurrViewerFeatures  = arrMainViewerFeatures;
                arrCurrViewerFeatures[ 3 ] = jElement.data( 'position' );
                if ( isNaN( jElement.data( 'position' ) ) === false ) {
                    var objData = {
                        accountId: innovationliving.cylindo.const.accountId,
                        //sku: jMainViewer.data( 'sku' ),
                        productCode: jMainViewer.data('sku'),
                        country: 'us',
                        lang: 'eng',
                        features: arrCurrViewerFeatures,
                        ssl: 1,
                        frame: 1,
                        size: 200
                    };
                    innovationliving.cylindo.enrichThumbnailWithImage( jElement, objData );
                }
            } );
            arrMainViewerFeatures[ 3 ] = strFallbackPosition;
        }
    },
    setParamInList: function () {
        var jElementCheckedColor = jQuery( '.js-e-productlist-filter[name="Color"]:checked' );
        if ( jQuery( '.js-product-cylindo' ).length === 0 && innovationliving.cylindo.const.isDownloadManager === false ) {
            window.localStorage.removeItem( 'innovationliving.cylindo.productlist.fabric' );
            var strFabric = innovationliving.cylindo.const.parameter.fabricMaterial;
            if ( jElementCheckedColor.length > 0 ) {
                strFabric                                               = innovationliving.cylindo.storeFabric( jElementCheckedColor.val() );
                innovationliving.cylindo.const.parameter.fabricMaterial = strFabric;
            }
            innovationliving.cylindo.changeFabricInUrlInList();
        }
    },
    cart: {
        build: function () {
            jQuery( '.js-cart-orderlines-cylindo' ).find( '.js-cylindo-image' ).each( function ( intIndex, element ) {
                var jElement        = jQuery( element ),
                    objData         = {},
                    boolUsePimPacks = ( jElement.data( 'use-pim-packs' ) === 'True' || jElement.data( 'use-pim-packs' ) === 'true' || jElement.data( 'use-pim-packs' ) === true );
                if ( isNaN( jElement.data( 'position' ) ) === false ) {
                    objData = {
                        accountId: innovationliving.cylindo.const.accountId,
                        productCode: jElement.data('sku'),
                        country: 'us',
                        lang: 'eng',
                        features: [
                            'FABRIC',
                            jElement.data( 'fabric' ),
                            'POSITION',
                            jElement.data( 'position' )
                        ],
                        ssl: 1,
                        frame: 4,
                        size: 200
                    };
                    if ( jElement.data( 'leg-finish' ) !== '' ) {
                        objData.features = [
                            'FABRIC',
                            jElement.data( 'fabric' ),
                            'POSITION',
                            jElement.data( 'position' ),
                            'LEG FINISH',
                            jElement.data( 'leg-finish' )
                        ];
                    }
                    if ( boolUsePimPacks === true ) {
                        innovationliving.cylindo.enrichViewerWithPIMPacks( jElement );
                    }
                    else {
                        innovationliving.cylindo.productExists(innovationliving.cylindo.modifySKU( jElement.data( 'sku' ) ))
                                .done(function( data, textStatus, jqXHR ){
                                    console.log('done', data, textStatus, jqXHR);
                                    innovationliving.cylindo.enrichElementWithImage( jElement, objData );
                                })
                                .fail(function( jqXHR, textStatus, errorThrown){
                                    console.log('fail', jqXHR, textStatus, errorThrown);
                                    innovationliving.cylindo.enrichViewerWithPIMPacks( jElement );
                                });
                    }
                }
            } );
        }
    },
    downloadmanager: {
        viewer: [],
        build: function () {
            jQuery( '.js-download-cart-orderlines-cylindo' ).find( '.js-cylindo-image' ).each( function ( intIndex, element ) {
                var jElement        = jQuery( element ),
                    objData         = {},
                    boolUsePimPacks = ( jElement.data( 'use-pim-packs' ) === 'True' || jElement.data( 'use-pim-packs' ) === 'true' || jElement.data( 'use-pim-packs' ) === true );
                if ( isNaN( jElement.data( 'position' ) ) === false ) {
                    objData = {
                        accountId: innovationliving.cylindo.const.accountId,
                        //sku: jElement.data( 'sku' ),
                        productCode: jElement.data('sku'),
                        country: 'us',
                        lang: 'eng',
                        features: [
                            'FABRIC',
                            jElement.data( 'fabric' ),
                            'POSITION',
                            jElement.data( 'position' )
                        ],
                        ssl: 1,
                        frame: 4,
                        size: 200
                    };
                    if ( jElement.data( 'leg-finish' ) !== '' ) {
                        objData.features = [
                            'FABRIC',
                            jElement.data( 'fabric' ),
                            'POSITION',
                            jElement.data( 'position' ),
                            'LEG FINISH',
                            jElement.data( 'leg-finish' )
                        ];
                    }
                    if ( boolUsePimPacks === true ) {
                        innovationliving.cylindo.enrichViewerWithPIMPacks( jElement );
                    }
                    else {
                        innovationliving.cylindo.productExists(innovationliving.cylindo.modifySKU( jElement.data( 'sku' ) ))
                                .done(function( data, textStatus, jqXHR ){
                                    console.log('done', data, textStatus, jqXHR);
                                    innovationliving.cylindo.enrichElementWithImage( jElement, objData );
                                })
                                .fail(function( jqXHR, textStatus, errorThrown){
                                    console.log('fail', jqXHR, textStatus, errorThrown);
                                    innovationliving.cylindo.enrichViewerWithPIMPacks( jElement );
                                });


                        /*innovationliving.cylindo.framework.viewer.services.skuExists( innovationliving.cylindo.const.accountId, innovationliving.cylindo.modifySKU( jElement.data( 'sku' ) ), function ( boolResult ) {
                            if ( boolResult === false || false ) {
                                innovationliving.cylindo.enrichViewerWithPIMPacks( jElement );
                            }
                            else {
                                innovationliving.cylindo.enrichElementWithImage( jElement, objData );
                            }
                        } );*/
                    }
                }
            } );
        }
    },
    productlist: {
        viewer: [],
        build: function () {
            innovationliving.cylindo.setParamInList();
            innovationliving.cylindo.productlist.viewer = [];
            var strFabric = innovationliving.cylindo.getActiveFabricInList();

            var useObserver = true;
            if(useObserver){
                var arrLazyloadTargets = jQuery( '.js-productlist-cylindo' ).find( '.js-cylindo-viewer').toArray();
                if ( arrLazyloadTargets.length ) {
                    e4.util.observer.bind( arrLazyloadTargets, innovationliving.cylindo.actionsForEachElement,
                            {
                                root: null,
                                rootMargin: '0px 0px 250px 0px',
                                threshold: 0
                            });
                }
            } else {
                jQuery( '.js-productlist-cylindo' ).find( '.js-cylindo-viewer' ).each( function ( intIndex, element ) {
                    var jElement        = jQuery( element ),
                        boolUsePimPacks = ( jElement.data( 'use-pim-packs' ) === 'True' || jElement.data( 'use-pim-packs' ) === 'true' || jElement.data( 'use-pim-packs' ) === true );
                    var strObjFabric    = strFabric;
                    if ( strFabric === null || strFabric === 'undefined' || innovationliving.cylindo.const.isDownloadManager ) {
                        strObjFabric = jElement.data( 'fabric' );
                    }
                    /*var objOptions = {
                        SKU: innovationliving.cylindo.modifySKU( jElement.data( 'sku' ) ),
                        accountID: innovationliving.cylindo.const.accountId,
                        features: [
                            'FABRIC',
                            strObjFabric,
                            'POSITION',
                            jElement.data( 'position' )
                        ],
                        country: 'us',
                        containerID: jElement.attr( 'id' ),
                        thumbs: false,
                        zoom: false,
                        startFrame: 4,
                        fullscreen: false,
                        tooltipDragText: null,
                        progressBar: false,
                        fallbackImage: jElement.data( 'fallback-image' )
                    };
                    if ( jElement.data( 'leg-finish' ) !== '' ) {
                        objOptions.features = [
                            'FABRIC',
                            strObjFabric,
                            'LEG FINISH',
                            jElement.data( 'leg-finish' ),
                            'POSITION',
                            jElement.data( 'position' )
                        ];
                    }*/

                    var objOptions = {
                        accountId: innovationliving.cylindo.const.accountId,
                        //sku: innovationliving.cylindo.modifySKU( jElement.data( 'sku' ) ),
                        productCode: innovationliving.cylindo.modifySKU( jElement.data( 'sku' ) ),
                        country: 'us',
                        lang: 'eng',
                        features: [
                            'FABRIC',
                            strObjFabric,
                            'POSITION',
                            jElement.data( 'position' )
                        ],
                        ssl: 1,
                        frame: 4,
                        size: 200
                    };
                    if ( jElement.data( 'leg-finish' ) !== '' ) {
                        objOptions.features = [
                            'FABRIC',
                            strObjFabric,
                            'LEG FINISH',
                            jElement.data( 'leg-finish' ),
                            'POSITION',
                            jElement.data( 'position' )

                        ];
                    }

                    innovationliving.cylindo.productlist.viewer[ intIndex ] = null;
                    if ( boolUsePimPacks === true ) {
                        innovationliving.cylindo.enrichViewerWithPIMPacks( jElement );
                    }
                    else {
                        innovationliving.cylindo.productExists(innovationliving.cylindo.modifySKU( jElement.data( 'sku' ) ))
                                .done(function( data, textStatus, jqXHR ){
                                    console.log('done', data, textStatus, jqXHR);
                                    innovationliving.cylindo.enrichElementWithImage( jElement, objOptions );
                                })
                                .fail(function( jqXHR, textStatus, errorThrown){
                                    console.log('fail', jqXHR, textStatus, errorThrown);
                                    innovationliving.cylindo.enrichViewerWithPIMPacks( jElement );
                                });

                        /*innovationliving.cylindo.framework.viewer.services.skuExists( innovationliving.cylindo.const.accountId, innovationliving.cylindo.modifySKU( jElement.data( 'sku' ) ), function ( boolResult ) {
                            if ( boolResult === true || true) {
                                //innovationliving.cylindo.productlist.viewer[ intIndex ] = innovationliving.cylindo.framework.viewer.create( objOptions );
                                console.log('enrichElementWithImage');
                                innovationliving.cylindo.enrichElementWithImage( jElement, objOptions );
                            }
                            else {
                                innovationliving.cylindo.enrichViewerWithPIMPacks( jElement );
                            }
                        } );*/
                    }
                } );
            }
        }
    },
    actionsForEachElement: function( element, observer ){
        var strFabric = innovationliving.cylindo.getActiveFabricInList();
        if ( element.isIntersecting === true ) {
            console.log(element);
            var elementTarget = element.target,
                jElement        = jQuery( elementTarget ),
                boolUsePimPacks = ( jElement.data( 'use-pim-packs' ) === 'True' || jElement.data( 'use-pim-packs' ) === 'true' || jElement.data( 'use-pim-packs' ) === true );
            var strObjFabric    = strFabric;
            if ( strFabric === null || strFabric === 'undefined' || innovationliving.cylindo.const.isDownloadManager ) {
                strObjFabric = jElement.data( 'fabric' );
            }
            /*var objOptions = {
                SKU: innovationliving.cylindo.modifySKU( jElement.data( 'sku' ) ),
                accountID: innovationliving.cylindo.const.accountId,
                features: [
                    'FABRIC',
                    strObjFabric,
                    'POSITION',
                    jElement.data( 'position' )
                ],
                country: 'us',
                containerID: jElement.attr( 'id' ),
                thumbs: false,
                zoom: false,
                startFrame: 4,
                fullscreen: false,
                tooltipDragText: null,
                progressBar: false,
                fallbackImage: jElement.data( 'fallback-image' )
            };
            if ( jElement.data( 'leg-finish' ) !== '' ) {
                objOptions.features = [
                    'FABRIC',
                    strObjFabric,
                    'LEG FINISH',
                    jElement.data( 'leg-finish' ),
                    'POSITION',
                    jElement.data( 'position' )
                ];
            }*/

            var objOptions = {
                accountId: innovationliving.cylindo.const.accountId,
                //sku: jElement.data( 'sku' ),
                productCode:  jElement.data( 'sku' ),
                country: 'us',
                lang: 'eng',
                features: [
                    'FABRIC',
                    strObjFabric,
                    'POSITION',
                    jElement.data( 'position' )
                ],
                ssl: 1,
                frame: 4,
                size: 600
            };
            if ( jElement.data( 'leg-finish' ) !== '' ) {
                objOptions.features = [
                    'FABRIC',
                    strObjFabric,
                    'LEG FINISH',
                    jElement.data( 'leg-finish' ),
                    'POSITION',
                    jElement.data( 'position' )

                ];
            }

            //innovationliving.cylindo.productlist.viewer[ intIndex ] = null;
            if ( boolUsePimPacks === true ) {
                innovationliving.cylindo.enrichViewerWithPIMPacks( jElement );
            }
            else {
                console.log('_1_', jElement.data( 'sku' ));
                console.log('jElement', jElement);
                var strModifiedSKU = innovationliving.cylindo.modifySKU( jElement.data( 'sku' ));
                console.log('strModifiedSKU', strModifiedSKU);

                innovationliving.cylindo.productExists(strModifiedSKU)
                        .done(function( data, textStatus, jqXHR ){
                            console.log('done', data, textStatus, jqXHR);
                            console.log('enrichElementWithImage');
                            console.log(jElement);
                            console.log(objOptions);
                            innovationliving.cylindo.enrichElementWithImage( jElement, objOptions );
                        })
                        .fail(function( jqXHR, textStatus, errorThrown){
                            console.log('fail', jqXHR, textStatus, errorThrown);
                            innovationliving.cylindo.enrichViewerWithPIMPacks( jElement );
                        });

                /*innovationliving.cylindo.framework.viewer.services.skuExists( innovationliving.cylindo.const.accountId, strModifiedSKU, function ( boolResult ) {
                    if ( boolResult === true || true ) {
                        //innovationliving.cylindo.productlist.viewer.push(innovationliving.cylindo.framework.viewer.create( objOptions ));
                        console.log('enrichElementWithImage');
                        console.log(jElement);
                        console.log(objOptions);
                        innovationliving.cylindo.enrichElementWithImage( jElement, objOptions );
                    }
                    else {
                        innovationliving.cylindo.enrichViewerWithPIMPacks( jElement );
                    }
                } );*/
            }
            observer.unobserve( elementTarget );
        }
    },
    switchToEspressoImageCarousel: function () {
        console.log( 'switchToEspressoImageCarousel' );
        jQuery( '.js-e-product-image-container' ).removeClass( 'collapse-product-images' );
    },
    switchToCylindoViewer: function () {
        console.log( 'switchToCylindoViewer' );
        jQuery( '.js-cylindo-viewer-container' ).removeClass( 'collapse-product-images' );
    },
    enrichViewerWithPIMPacks: function ( jElement ) {
        if(jElement.data('cylindooverrideurl')) {
            innovationliving.cylindo.enrichElementWithImage( jElement, null );
        } else {
            if ( jElement[ 0 ].tagName === 'IMG' ) {
                jElement.attr( 'src', jElement.data( 'fallback-image' ) );
            }
            else {
                jElement.css( {
                    'background-image': 'url("' + jElement.data( 'fallback-image' ) + '")'
                } );
            }
        }
    },
    enrichElementWithHoverImage: function ( jElement, objData ) {
        console.log('HOVERimage', innovationliving.cylindo.const.url.getImageUrl, jElement, objData);
        var jHoverElement = jElement.find('.hover');
        var strUrl = '';
        var overrideUrl = jHoverElement.data('cylindooverrideurl');
        if(overrideUrl) {
            strUrl = '/admin/public/getimage.ashx?Image=' + overrideUrl + '&Crop=0&Format=webp&Width=800&Quality=90';
        } else {
            strUrl = innovationliving.cylindo.const.url.getImageV4
                    .split('{productCode}').join(objData.productCode)
                    .split('{accountid}').join(objData.accountId)
                    .split('{frame}').join(objData.frame);
    
            var strParamFeature = '';
            for (var i = 0; i < objData.features.length; ++i) {
                var strFeatureName = objData.features[i];
                var strFeatureValue = objData.features[i+1];
    
                if(strFeatureName === 'POSITION'){
                    strFeatureValue = jElement.data('hoverPosition');
                }
    
                strParamFeature += 'feature=' + strFeatureName + ':' + strFeatureValue + '&';
                ++i;
            }
            strUrl = strUrl +'?'+strParamFeature + 'size='+ objData.size;
        }

        if ( jHoverElement[ 0 ].tagName === 'IMG' ) {
            jHoverElement.attr( 'src', strUrl );
        }
        else {
            jHoverElement.css( {
                'background-image': 'url("' + strUrl + '")'
            } );
        }
    },
    enrichElementWithImage: function ( jElement, objData ) {
        var overrideUrl = jElement.data('cylindooverrideurl');
        var strUrl = '';
        
        console.log('func_enrichElementWithImage', innovationliving.cylindo.const.url.getImageUrl, jElement, objData);
        if(jElement.data('hoverPosition') !== '' && jElement.find('.hover').length > 0){
            jElement.closest('.e-products-item').addClass('e-products-item-hover');
            innovationliving.cylindo.enrichElementWithHoverImage( jElement, objData );
        }
        
        if(overrideUrl) {
            strUrl = '/admin/public/getimage.ashx?Image=' + overrideUrl + '&Crop=0&Format=webp&Width=800&Quality=90';
        } else {
            strUrl = innovationliving.cylindo.const.url.getImageV4
                    .split('{productCode}').join(objData.productCode)
                    .split('{accountid}').join(objData.accountId)
                    .split('{frame}').join(objData.frame);
    
            var strParamFeature = '';
            for (var i = 0; i < objData.features.length; ++i) {
                strParamFeature += 'feature=' + objData.features[i] + ':' + objData.features[i+1] + '&';
                console.log('for_', objData.features[i], objData.features[i+1]);
                ++i;
            }
            strUrl = strUrl +'?'+strParamFeature + 'size='+ objData.size;
        }

        console.log('imageUrl', strUrl);

        if ( jElement[ 0 ].tagName === 'IMG' ) {
            jElement.attr( 'src', strUrl );
        }
        else {
            jElement.css( {
                'background-image': 'url("' + strUrl + '")'
            } );
        }
    },
    enrichThumbnailWithImage: function ( jElement, objData ) {
        console.log( 'enrichThumbnailWithImage', innovationliving.cylindo.const.url.getImageUrl, objData );
        var strUrl = innovationliving.cylindo.const.url.getImageV4
                .split('{productCode}').join(objData.productCode)
                .split('{accountid}').join(objData.accountId)
                .split('{frame}').join(objData.frame);

        var strParamFeature = '';
        for (var i = 0; i < objData.features.length; ++i) {
            strParamFeature += 'feature=' + objData.features[i] + ':' + objData.features[i+1] + '&';
            console.log('for_', objData.features[i], objData.features[i+1]);
            ++i;
        }
        strUrl = strUrl +'?'+strParamFeature + 'size='+ objData.size;

        console.log('imageUrl', strUrl);

        jElement.css( {
            'background-image': 'url("' + strUrl + '")'
        } );
    },
    changeFabricInUrl: function ( strFabric ) {
        var strPageUrlWithParams = location.origin + location.pathname + '?fabric=' + innovationliving.cylindo.data[ strFabric ][ 0 ].paramValue;
        jQuery( '.js-il-product-page-email-form' ).find( 'input[name="SubmitPage"]' ).val( strPageUrlWithParams );
        history.replaceState( null, null, strPageUrlWithParams );
    },
    changeFabricInUrlInList: function () {
        var boolSetFabricParam = ( innovationliving.cylindo.getActiveFabricInList() !== 'undefined' && innovationliving.cylindo.getActiveFabricInList() !== undefined && innovationliving.cylindo.getActiveFabricInList() !== null && jQuery( '.js-e-productlist-form' ).length > 0 );
        if ( boolSetFabricParam ) {
            if(location.search.indexOf('fabric=') === -1 && innovationliving.cylindo.const.allowRecallProductlistData){
                innovationliving.cylindo.const.allowRecallProductlistData = false;
                e4.productlist.data.post();
            }
            history.replaceState( null, null, location.origin + location.pathname + '?fabric=' + innovationliving.cylindo.getActiveFabric() );
        }
        else {
            history.replaceState( null, null, location.origin + location.pathname );
        }
    },
    clearFabric: function () {
        window.localStorage.clear();
        innovationliving.cylindo.const.stored.fabricMaterial    = null;
        innovationliving.cylindo.const.parameter.fabricMaterial = null;
        history.replaceState( null, null, location.origin + location.pathname );
    },
    storeFabric: function ( strFabric ) {
        window.localStorage.setItem( 'innovationliving.cylindo.productlist.fabric', strFabric );
        innovationliving.cylindo.const.stored.fabricMaterial = window.localStorage.getItem( 'innovationliving.cylindo.productlist.fabric' );
        return strFabric;
    },
    changeFabricInList: function ( strFabric ) {
        jQuery( innovationliving.cylindo.productlist.viewer ).each( function ( intIndex, objViewer ) {
            if ( objViewer !== null ) {
                var arrViewerFeatures  = objViewer.getFeatures();
                arrViewerFeatures[ 1 ] = strFabric;
                innovationliving.cylindo.changeFeatures( objViewer, arrViewerFeatures );
            }
        } );
    },
    changeFeatures: function ( objViewer, arrViewerFeatures ) {
        console.log( 'changeFeatures', arrViewerFeatures );
        objViewer.setFeatures( arrViewerFeatures );
    },
    changeRotation: function ( objViewer ) {
        objViewer.rotate( 40, 200 );
    },
    setActiveFabric: function () {
        var strActiveFabric = innovationliving.cylindo.getActiveFabric();
        jQuery( '.js-product-cylindo' ).find( '.js-variant-color[data-fabric="' + strActiveFabric + '"]' ).prop( 'checked', true ).trigger( 'change' );
    },
    getActiveFabricInList: function () {
        var strReturn = innovationliving.cylindo.const.parameter.fabricMaterial;
        if ( strReturn === null ) {
            strReturn = innovationliving.cylindo.const.stored.fabricMaterial;
        }
        if ( strReturn === undefined ) {
            strReturn = innovationliving.cylindo.const.default.fabricMaterial;
        }
        return strReturn;
    },
    getActiveFabric: function () {
        var jElement  = jQuery( '.js-product-cylindo' ).find( '.js-cylindo-viewer' ),
            strReturn = innovationliving.cylindo.const.parameter.fabricMaterial;
        if ( strReturn === null ) {
            strReturn = innovationliving.cylindo.const.stored.fabricMaterial;
        }
        if ( strReturn === null ) {
            strReturn = jElement.data( 'fabric' );
        }
        if ( strReturn === undefined ) {
            strReturn = innovationliving.cylindo.const.default.fabricMaterial;
        }
        return strReturn;
    },
    setActivePosition: function () {
        var jElement          = jQuery( '.js-product-cylindo' ).find( '.js-cylindo-viewer' ),
            strActivePosition = jElement.data( 'position' );
        jQuery( '.js-cylindo-thumbs[data-position="' + strActivePosition + '"]' ).addClass( 'active' );
    },
    getFabricIdFromParam: function ( strParam ) {
        if ( isNaN( strParam ) ) {
            strParam = strParam.split( '-' )[ 0 ];
        }
        return strParam;
    }
};
